<template>
  <div id="app" class="container">
    <div class="content">
      <a href="/" @click.prevent="goToHome"><img src="../assets/images/logo.png" id="logo" height="100" alt="Logo iZZi"></a>
      <h1>iZZi transfert</h1>
      <p>
        Transférez vos fichiers en toute simplicité.
      </p>

      <hr>

      <router-view></router-view>

      <div class="has-text-centered">
        <p>
          © 2017{{ new Date().getFullYear() > 2017 ? `-${new Date().getFullYear()}` : '' }} iZZi Transfert
          |
          <a href="http://www.izziweb.fr/mentions-legales/" target="_blank">Mentions légales</a>
          |
          <a href="http://www.izziweb.fr/#contact-section" target="_blank">Contact</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    methods: {
      goToHome () {
        window.location.replace('/')
      }
    }
  }
</script>

<style lang="sass">
    $izzired: #e80001
    $primary: $izzired
    @import "~bulma"

    body
        text-align: center;
    
    .button
        color: white;
        background-color: $izzired;
        border-color: white;
    
    .button:hover
        color: $izzired;
        background-color: white;
        border-color: $izzired;
    
    .button:active
        color: black;
        background-color: white;
        border-color: black;
</style>



// WEBPACK FOOTER //
// App.vue?341e4ca1